module.exports = __webpack_public_path__ + "static/media/mias.a4c7cbf6.png";